import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { addUserActivityTrigger } from '../../slices/authSlice';
import { AppDispatch } from '../../store';

const UserLogActivity = () => {
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();

  const addUserActivity = (
    request: Record<string, unknown>,
    eventName: string,
    description: string,
    screen: string | undefined,
  ) => {
    console.log('🟡 DEBUG: UserActivity addUserActivity called:', {
      eventName,
      description,
      screen,
      request: Object.keys(request)
    });
    
    const screenName = screen ? screen : localStorage.getItem('menuName') || '';
    const slug = location.pathname;
    dispatch(addUserActivityTrigger({ request, screenName, eventName, slug, description }));
  };

  return { addUserActivity };
};

export default UserLogActivity;
